import React from 'react';
import { createContext, useContext } from 'use-context-selector';

export type EligibilityPlanProps = {
  id_convenio: number;
  id_cliente: number;
  cod_convenio: string;
  cod_plano: string;
  cod_escritorio: string;
  nome: string;
  image: string;
  unidades?: string[];
};

export type PaymentContextProps = {
  eligibilityPlans: EligibilityPlanProps[];
  setEligibilityPlans: (plans: EligibilityPlanProps[]) => void;
  clearEligibilityPlans: () => void;
};

type PaymentProviderProps = {
  children: React.ReactNode;
};

export const PaymentContext = createContext({} as PaymentContextProps);

export function PaymentProvider({ children }: PaymentProviderProps) {
  const [eligibilityPlans, setEligibilityPlans] = React.useState<EligibilityPlanProps[]>([]);

  const clearEligibilityPlans = () => {
    setEligibilityPlans([]);
  };

  return (
    <PaymentContext.Provider
      value={{
        eligibilityPlans,
        setEligibilityPlans,
        clearEligibilityPlans
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
}

export function usePaymentContext() {
  return useContext(PaymentContext);
}
